import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

function TagPill({ label }) {
    return <span className="badge badge-pill badge-outline">{label}</span>;
}

TagPill.propTypes = {
    label: PropTypes.string,
};

TagPill.defaultProps = {
    label: '',
};

export default TagPill;
